import flatten from 'lodash/flatten';
import { createSelector } from 'reselect';

import { AppState } from 'src/config/appState';

import { getCPProgramState } from '../../selectors/cpProgramSelectors';
import { ActivitiesSelectionDomain, LivingAccordingToValues } from '../models/weekThree';

export const getLivingAccordingToValuesFeelings = (state: AppState): LivingAccordingToValues =>
    getCPProgramState(state).livingAccordingToValues;

export const areLivingValuesValid = createSelector(
    getLivingAccordingToValuesFeelings,
    ({ livingWithValuesFeelings, livingAgainstValuesFeelings }): boolean =>
        livingWithValuesFeelings != '' && livingAgainstValuesFeelings != '',
);

export const getSelectedDomains = (state: AppState): ActivitiesSelectionDomain[] =>
    getCPProgramState(state).activitiesSelection;

export const getPlannedActivities = createSelector(getSelectedDomains, domains => {
    const areaPlannedActivities = flatten(
        domains.map(domain =>
            domain.activities
                .filter(activity => activity.isChosen)
                .map(activity => ({
                    domainId: domain.id,
                    domainTitle: domain.title,
                    title: activity.description,
                    additionalTitle: activity.additionalTitle,
                    dateToBePerformed: activity.dateToBePerformed,
                    completed: activity.completed,
                    checkInActionsAnswer: activity.checkInActionsAnswer,
                    id: activity.id,
                })),
        ),
    );

    return areaPlannedActivities;
});

export const getRemainingActivitiesCount = createSelector(
    getPlannedActivities,
    plannedActivities => 3 - plannedActivities.length, // Supposed number of activities is 3 by design
);

export const isActionsSelectionDataValid = createSelector(
    getPlannedActivities,
    plannedActivities => plannedActivities.length === 3,
);

export const isCheckInAboutPracticeDataValid = createSelector(
    getPlannedActivities,
    activities =>
        !activities.find(
            activity =>
                (activity.completed === true &&
                    activity.checkInActionsAnswer === undefined &&
                    activity.additionalTitle === undefined) ||
                activity.completed === undefined,
        ),
);
